// routes

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;
export const VISA_BACKEND_API = process.env.REACT_APP_VISA_BACKEND_API;
export const BACKEND_API = process.env.REACT_APP_BACKEND_API;
export const MAKE_DOT_COM_CONTACT_FORM = process.env.REACT_APP_MAKE_DOT_COM_CONTACT_FORM;

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const FCM_KEY = process.env.REACT_APP_FCM_KEY;

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = '/'; // as '/'

export const whatsappLink = 'https://wa.me/919266863989?text=Hi';

export const Rating_Api = process.env.REACT_APP_RATING;

export const Registration_Submition = process.env.REACT_APP_REGISTRATION_SUBMITION;

export const SUBMIT_LAUNCH_OFFER_EMAIL =
  'https://hook.us1.make.com/mh1u47hj4ajzcb5xa07nqgkkfqv6effb';
